import { render, staticRenderFns } from "./PaymentButton.vue?vue&type=template&id=9306b334"
import script from "./PaymentButton.vue?vue&type=script&lang=js"
export * from "./PaymentButton.vue?vue&type=script&lang=js"
import style0 from "./PaymentButton.vue?vue&type=style&index=0&id=9306b334&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/maq/Code/skyier/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9306b334')) {
      api.createRecord('9306b334', component.options)
    } else {
      api.reload('9306b334', component.options)
    }
    module.hot.accept("./PaymentButton.vue?vue&type=template&id=9306b334", function () {
      api.rerender('9306b334', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/checkout/components/PaymentButton.vue"
export default component.exports